export const clampToMoney = (value: number): number => Number(value.toFixed(1));

export const computeEqualSplitAmounts = (totalAmount: number, count: number): number[] => {
  if (count <= 0) {
    return [];
  }
  const totalTenths = Math.round(totalAmount * 10);
  const baseTenths = Math.floor(totalTenths / count);
  const remainderTenths = totalTenths - baseTenths * count;
  return Array.from({ length: count }, (_, index) =>
    Number(((baseTenths + (index < remainderTenths ? 1 : 0)) / 10).toFixed(1)),
  );
};

export const computeEqualSplitAmount = (totalAmount: number, count: number): number => {
  const amounts = computeEqualSplitAmounts(totalAmount, count);
  return amounts[0] ?? 0;
};

export const computeCustomRemainder = (totalAmount: number, customAmount: number): number => {
  return clampToMoney(totalAmount - customAmount);
};

export const isCustomSplitValid = (totalAmount: number, customAmount: number): boolean => {
  return customAmount > 0 && customAmount < totalAmount;
};
